// extracted by mini-css-extract-plugin
export default {"container":"style_container__uPrZ7","content":"style_content__7vYGq","header":"style_header__Plrms","description":"style_description__oVZXy"};